import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Observable, of } from 'rxjs';
import { FrontpageAlertData } from '@mwe/models';
import { HeaderNotificationData } from '../../model/header-notification.model';
import { FaqData } from '../../model/faq.model';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IkpStaticContentService extends ApiService {
  getTemporaryAlert(): Observable<FrontpageAlertData> {
    return this.httpClient.get<FrontpageAlertData>(`${this.staticContentUrl}/config/frontpage-alert.json`);
  }

  getStaticFAQs(): Observable<FaqData[]> {
    return this.httpClient.get<FaqData[]>(`${this.staticContentUrl}/faq/faqs-with-categories.json`);
  }

  getHeaderNotification(): Observable<HeaderNotificationData | null> {
    return this.httpClient.get<HeaderNotificationData>(`${this.staticContentUrl}/config/header-notification.json`).pipe(
      catchError(error => {
        console.error('Could not fetch header notification', error);
        return of(null);
      }),
    );
  }

  getUmmeldungAnleitungPdfUrl(): string {
    return `${this.staticContentUrl}/documents/Anleitung_Ummeldung.pdf`;
  }
}
